export const validateEmail = (email) => {
    if (!email) return true
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).trim().toLowerCase());
}

export function regexIsRomanji(input) {
    return /^[0-9A-Za-z!@#%&*()+:""\-;',.\/_ ]+$/.test(input)
}

export const regexAlphabet = (input) => {
    return /^[A-Za-z ]+$/.test(input)
}

export const regexAlphabetNotSpaces = (input) => {
    return /^[A-Za-z]+$/.test(input)
}

export const regexNumber = (input) => {
    return /\d/.test(input)
}

export const fullSize = (input) => {
    return /^[^ -~｡-ﾟ\x00-\x1f\t]+$/.test(input)
}

export const regexJapanese = (input) => {
    return /[一-龠]+|[ぁ-ゔ]+|[ァ-ヴー]＋|[ｧ-ﾝﾞﾟ]+|[ａ-ｚＡ-Ｚ０-９]+|[々〆〤]+/u.test(input)
}

export const regexName = (input) => {
    return /[\$\\\[\]\^\t]+/.test(input)
}

export const regexPhone = (input) => {
    return /^[0-9()\-+]+$/.test(input)
}

export const atLeastOneUperCase = (input) => {
    return /(?=.*?[A-Z])/.test(input)
} 

export const atLeastOneLowerCase = (input) => {
    return /(?=.*?[a-z])/.test(input)
}

export const atLeastOneNumber = (input) => {
    return /(?=.*\d)/.test(input)
}

export const regexAllCharacter = (input) => {
    return /^[a-zA-Z0-9!@#$%^&*()_+=`~[{}\]\|'";:.,<>\/?\-\\ ]+$/.test(input)
}

export const regexContainSpaces = (input) => {
    return /^\S*$/.test(input)
}

export const regexExcludeNumber = /[a-zA-Z!@#$%^&*()_+=-`~[{}\]\|'";:,<>\/? ]/g

export const dateFormat = "MM/DD/YYYY HH:mm"

export const regexPassword = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/





// WEBPACK FOOTER //
// ./src/services/ruleValidate.js